import { isPublic } from '@core/router/utils';
import { Auth } from '@core/auth';

import FatalErrorTypeEnum from '@constants/enums/fatalErrorType';

import { Investor } from '@/models';

const redirectSuspendedOrganisation = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (auth.is_initialised && auth.is_investor && auth.is_owner && to.name !== 'FatalError') {
            const investor = await Investor.$get(auth.organisation_id);

            if (investor.is_suspended) {
                next({
                    name: 'FatalError',
                    query: {
                        ...to.query,
                        type: FatalErrorTypeEnum.SUSPENDED,
                        signout_url: auth.signout_url
                    }
                });
            } else {
                next();
            }
        } else {
            next();
        }
    }
};

export default redirectSuspendedOrganisation;
